<template>
    <div class="form-group">
        <!--<label class="form-control-placeholder" v-html="isRequired ? label + '*' : label" v-bind:for="id"></label>-->
        <input :disabled="disabled"
               :id="id"
               :min="min"
               :name="name"
               :placeholder="isRequired ? `${placeholder}*` : placeholder"
               :type="type"
               autocomplete="off"
               @input="$emit('input', $event.target.value)"
               class="form-control"
               v-model="InputData"
               v-on:change="inputChanged()">
    </div>
</template>

<script>

    export default {
        name: 'Input',
        $_veeValidate: {
            // value getter
            value () {
                return this.InputData;
            },
            // name getter
            name () {
                return this.name;
            }
        },
        props: {
            min: {
                type: Number,
                required: false
            },
            name: {
                type: String,
                required: false
            },
            label: {
                type: String,
                required: false
            },
            placeholder: {
                type: String,
                required: false
            },
            type: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                required: false
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            value: {},
            validation: {}
        },
        data () {
            return {
                InputData: undefined
            };
        },
        created () {
            this.InputData = this.value;
        },
        watch: {
            value (newValue) {
                this.InputData = newValue;
            }
        },
        methods: {
            inputChanged () {
                this.$emit('input', this.InputData);
                if (typeof this.change === 'function') {
                    this.change();
                }
            }
        }
    };

</script>

<style lang="scss" scoped>
</style>
